import { z } from 'zod';

export const SearchResultAdvisorZod = z.object({
    participantId: z.number(),
    fullName: z.string(),
    organizationName: z.string().optional().nullable(),
    email: z.string(),
    parentGroupId: z.number(),
});
export type SearchResultAdvisor = z.infer<typeof SearchResultAdvisorZod>;
